import request from '@/utils/request'

export const tenantListApi = (data) => {
  return request({
    url: 'Tenants/adminList',
    method: 'post',
    data
  })
}

export const tenantSaveApi = (data) => {
  return request({
    url: 'Tenants/adminSave',
    method: 'post',
    data
  })
}

export const tenantUpdateStatusApi = (data) => {
  return request({
    url: 'Tenants/adminUpdateStatus',
    method: 'post',
    data
  })
}

export const tenantRenewListApi = (data) => {
  return request({
    url: 'Tenants/adminRenewList',
    method: 'post',
    data
  })
}

export const tenantRenewApi = (data) => {
  return request({
    url: 'Tenants/adminRenew',
    method: 'post',
    data
  })
}

export const tenantSubscriptionLogListApi = (data) => {
  return request({
    url: 'Tenants/adminSubscriptionLogList',
    method: 'post',
    data
  })
}
